import { render, staticRenderFns } from "./DeviceRomAutoUploadAdmin.vue?vue&type=template&id=5d2a0c91&scoped=true"
import script from "./DeviceRomAutoUploadAdmin.vue?vue&type=script&lang=js"
export * from "./DeviceRomAutoUploadAdmin.vue?vue&type=script&lang=js"
import style0 from "./DeviceRomAutoUploadAdmin.vue?vue&type=style&index=0&id=5d2a0c91&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d2a0c91",
  null
  
)

export default component.exports